import * as React from 'react';
import { TabStyles } from '@tableau/widgets';
import { DIALOG_WIDTH } from '../../app/content/styles/ExternalContentActionsStyles';
import { ButtonType, DialogFooterButtonsWidget, DialogPositioningBehavior, DialogType } from '@tableau/widgets';
import { ReactModalService } from '../../ts/services/ReactModalService';
import { Messages } from '../../codegen/Localize';

export interface ReactAlertStringBodyProps {
    readonly title: string;
    readonly message: string;
}

export const ReactAlertStringBody = (props: ReactAlertStringBodyProps): JSX.Element => {
    return (
        <React.Fragment>
          <div className="tb-dialog-title">{props.title}</div>
          <div className="tb-alert-message tb-dialog-body-text">{props.message}</div>
        </React.Fragment>
    );
};

function openAlertDialog(option: ReactAlertStringBodyProps){
    const modal = ReactModalService.open({
        title: null,
        type: DialogType.Uber,
        positioningBehavior: DialogPositioningBehavior.Centered,
        dialogContent: <ReactAlertStringBody {...option}/>,
        dialogContentStyle: {
            paddingTop: TabStyles.Spacing.LargeSpace,
            paddingBottom: TabStyles.Spacing.SmallSpace
        },
        dialogWidth: DIALOG_WIDTH,
        footerContent: <DialogFooterButtonsWidget
            buttons={[
                {
                    handleClick: () => {
                        modal.close();
                    },
                    buttonType: ButtonType.Outline,
                    children: Messages.close(),
                    testId: 'footer-close'
                }
            ]}
            testId="footer"
        />
    });
    return modal;
}

export const DdaReactAlertDialog = {
    openAlertDialog,
};